export const FETCH_POSTS_BY_USER_REQUEST = "FETCH_POSTS_BY_USER_REQUEST";
export const FETCH_POSTS_BY_USER_SUCCESS = "FETCH_POSTS_BY_USER_SUCCESS";
export const FETCH_POSTS_BY_USER_FAIL = "FETCH_POSTS_BY_USER_FAIL";

export const FETCH_POST_BY_ID_REQUEST = "FETCH_POST_BY_ID_REQUEST";
export const FETCH_POST_BY_ID_SUCCESS = "FETCH_POST_BY_ID_SUCCESS";
export const FETCH_POST_BY_ID_FAIL = "FETCH_POST_BY_ID_FAIL";

export const CREATE_POST_REQUEST = "CREATE_POST_REQUEST";
export const CREATE_POST_SUCCESS = "CREATE_POST_SUCCESS";
export const CREATE_POST_FAIL = "CREATE_POST_FAIL";

export const UPDATE_POST_REQUEST = "UPDATE_POST_REQUEST";
export const UPDATE_POST_SUCCESS = "UPDATE_POST_SUCCESS";
export const UPDATE_POST_FAIL = "UPDATE_POST_FAIL";

export const DELETE_POST_REQUEST = "DELETE_POST_REQUEST";
export const DELETE_POST_SUCCESS = "DELETE_POST_SUCCESS";
export const DELETE_POST_FAIL = "DELETE_POST_FAIL";

export const POST_LIKE_REQUEST = "POST_LIKE_REQUEST";
export const POST_LIKE_SUCCESS = "POST_LIKE_SUCCESS";
export const POST_LIKE_FAIL = "POST_LIKE_FAIL";

export const POST_UNLIKE_REQUEST = "POST_UNLIKE_REQUEST";
export const POST_UNLIKE_SUCCESS = "POST_UNLIKE_SUCCESS";
export const POST_UNLIKE_FAIL = "POST_UNLIKE_FAIL";

export const POST_ADD_COMMENT_REQUEST = "POST_ADD_COMMENT_REQUEST";
export const POST_ADD_COMMENT_SUCCESS = "POST_ADD_COMMENT_SUCCESS";
export const POST_ADD_COMMENT_FAIL = "POST_ADD_COMMENT_FAIL";

export const POST_DELETE_COMMENT_REQUEST = "POST_DELETE_COMMENT_REQUEST";
export const POST_DELETE_COMMENT_SUCCESS = "POST_DELETE_COMMENT_SUCCESS";
export const POST_DELETE_COMMENT_FAIL = "POST_DELETE_COMMENT_FAIL";

export const POST_ADD_REPLY_REQUEST = "POST_ADD_REPLY_REQUEST";
export const POST_ADD_REPLY_SUCCESS = "POST_ADD_REPLY_SUCCESS";
export const POST_ADD_REPLY_FAIL = "POST_ADD_REPLY_FAIL";

export const POST_VOTE_POLL_REQUEST = "POST_VOTE_POLL_REQUEST";
export const POST_VOTE_POLL_SUCCESS = "POST_VOTE_POLL_SUCCESS";
export const POST_VOTE_POLL_FAIL = "POST_VOTE_POLL_FAIL";

export const UPLOAD_POST_MEDIA_REQUEST = "UPLOAD_POST_MEDIA_REQUEST";
export const UPLOAD_POST_MEDIA_SUCCESS = "UPLOAD_POST_MEDIA_SUCCESS";
export const UPLOAD_POST_MEDIA_FAIL = "UPLOAD_POST_MEDIA_FAIL";

export const RECORD_POST_VIEW_REQUEST = "RECORD_POST_VIEW_REQUEST";
export const RECORD_POST_VIEW_SUCCESS = "RECORD_POST_VIEW_SUCCESS";
export const RECORD_POST_VIEW_FAIL = "RECORD_POST_VIEW_FAIL";

export const FETCH_FEATURED_BY_USER_REQUEST = "FETCH_FEATURED_BY_USER_REQUEST";
export const FETCH_FEATURED_BY_USER_SUCCESS = "FETCH_FEATURED_BY_USER_SUCCESS";
export const FETCH_FEATURED_BY_USER_FAIL = "FETCH_FEATURED_BY_USER_FAIL";

export const FETCH_FEATURED_BY_ID_REQUEST = "FETCH_FEATURED_BY_ID_REQUEST";
export const FETCH_FEATURED_BY_ID_SUCCESS = "FETCH_FEATURED_BY_ID_SUCCESS";
export const FETCH_FEATURED_BY_ID_FAIL = "FETCH_FEATURED_BY_ID_FAIL";

export const CREATE_FEATURED_REQUEST = "CREATE_FEATURED_REQUEST";
export const CREATE_FEATURED_SUCCESS = "CREATE_FEATURED_SUCCESS";
export const CREATE_FEATURED_FAIL = "CREATE_FEATURED_FAIL";

export const UPDATE_FEATURED_REQUEST = "UPDATE_FEATURED_REQUEST";
export const UPDATE_FEATURED_SUCCESS = "UPDATE_FEATURED_SUCCESS";
export const UPDATE_FEATURED_FAIL = "UPDATE_FEATURED_FAIL";

export const DELETE_FEATURED_REQUEST = "DELETE_FEATURED_REQUEST";
export const DELETE_FEATURED_SUCCESS = "DELETE_FEATURED_SUCCESS";
export const DELETE_FEATURED_FAIL = "DELETE_FEATURED_FAIL";

export const ADD_POST_TO_FEATURED_REQUEST = "ADD_POST_TO_FEATURED_REQUEST";
export const ADD_POST_TO_FEATURED_SUCCESS = "ADD_POST_TO_FEATURED_SUCCESS";
export const ADD_POST_TO_FEATURED_FAIL = "ADD_POST_TO_FEATURED_FAIL";

export const REMOVE_POST_FROM_FEATURED_REQUEST =
  "REMOVE_POST_FROM_FEATURED_REQUEST";
export const REMOVE_POST_FROM_FEATURED_SUCCESS =
  "REMOVE_POST_FROM_FEATURED_SUCCESS";
export const REMOVE_POST_FROM_FEATURED_FAIL = "REMOVE_POST_FROM_FEATURED_FAIL";

export const RESET_POSTS_ERROR = "RESET_POSTS_ERROR";
